import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Card, CardContent } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'

const useStyles = makeStyles({
  root: {
    position: 'relative',
    minWidth: 180,
    height: '100%'
  }
})

export default function TableSkeleton ({ lineQuantity } : any): JSX.Element {
  const classes = useStyles()
  if (lineQuantity === undefined) {
    lineQuantity = 6
  }
  return (
    <Card className={classes.root}>
      <CardContent>
        {[...Array(lineQuantity)].map((e, index: number) => <>
          <Skeleton key={index} width="100%" height="32px" />
         </>)}
      </CardContent>
    </Card>
  )
}
